import { API_BASE, deviceTimeZone } from "./client";
import { useAuthStore } from "../auth/store";

/** Headers of a file download: the token and the zone this screen shows times in (BUG-008: the file says it too). */
export function downloadHeaders(): Record<string, string> {
  const token = useAuthStore.getState().accessToken;
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const zone = deviceTimeZone();
  if (zone) headers["X-Time-Zone"] = zone;
  // UX3010-13: an export holds the rows of the working organization, the same as the list on the screen
  const company = useAuthStore.getState().company;
  if (company) headers["X-Company-Id"] = company.id;
  return headers;
}

/** Downloads a file from an authenticated endpoint (exports, reports) with the browser's save dialog. */
export async function downloadFile(path: string, filename: string): Promise<void> {
  const response = await fetch(API_BASE + path, { headers: downloadHeaders() });
  if (!response.ok) {
    let detail = response.statusText;
    try {
      detail = (await response.json()).detail ?? detail;
    } catch {
      /* not json */
    }
    throw new Error(detail);
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
